<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="ParentData"
                @action="masterAction"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <g-lookup :label="$t('Persona')"
                      :formItemConfig="fiOptions"
                      endpoint="personas"
                      :decorator="['id_person', { rules: [{ required: true, message: 'Valor requerido' }]}]">
            </g-lookup>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'person_user',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_person_user'
            },
            columns: [
              {title: 'ID', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre', dataIndex: 'person_name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_person'}
          ]
        }
      }
    },
    props: ['name'],
    computed: {
      ParentData () {
        return {
          name: this.name
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('person_user/-1', {
                    data: {
                      id_person: action.record.id_person,
                      name: action.record.name
                    }
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/PersonUser.vue